import React, { useEffect } from "react";
import { useTranslation } from 'react-i18next';
import { NavLink } from "react-router-dom";
import { ReactComponent as LogoSVG } from '../src/images/logo.svg';
import * as bootstrap from 'bootstrap';

const Navbar = () => {
  const { t, i18n } = useTranslation();

  const toggleLanguage = () => {
    const newLang = i18n.language === 'en' ? 'fr' : 'en';
    i18n.changeLanguage(newLang);
  };

  useEffect(() => {
    const handleNavClick = () => {
      const collapseEl = document.getElementById('navbarSupportedContent');
      if (collapseEl && collapseEl.classList.contains('show')) {
        const bsCollapse = new bootstrap.Collapse(collapseEl, {
          toggle: false
        });
        bsCollapse.hide();
      }
    };
    
    const navLinks = document.querySelectorAll('.navbar-nav .nav-link');
    navLinks.forEach(link => link.addEventListener('click', handleNavClick));
    
    return () => {
      navLinks.forEach(link => link.removeEventListener('click', handleNavClick));
    };
  }, []);

  return (
    <div className="container-fluid nav_bg mb-0 pb-0">
      <div className="row">
        <div className="col-12">
          <nav className="navbar navbar-expand-lg navbar-light blue-color-code bg-light">
            <div className="container-fluid px-3">

              {/* Logo on the left */}
              <NavLink className="navbar-brand d-flex align-items-center" to="/">
                <LogoSVG style={{ height: "70px", width: "auto" }} alt="Logo" />
              </NavLink>

              {/* Hamburger toggler on the right (mobile only) */}
              <button
                className="navbar-toggler ms-auto "
                type="button"
                data-bs-toggle="collapse"
                data-bs-target="#navbarSupportedContent"
                aria-controls="navbarSupportedContent"
                aria-expanded="false"
                aria-label="Toggle navigation"
              >
                <span className="navbar-toggler-icon"></span>
              </button>

              {/* Nav links (collapsed in mobile) */}
              <div className="collapse navbar-collapse justify-content-end" id="navbarSupportedContent">
                <ul className="navbar-nav mb-2 mb-lg-0">
                  <li className="nav-item">
                    <NavLink to="/" end className="nav-link">
                      {t("home")}
                    </NavLink>
                  </li>
                  <li className="nav-item">
                    <NavLink to="/service" className="nav-link">
                      {t("service")}
                    </NavLink>
                  </li>
                  <li className="nav-item">
                    <NavLink to="/team" className="nav-link">
                      {t("team")}
                    </NavLink>
                  </li>
                  <li className="nav-item">
                    <NavLink to="/career" className="nav-link">
                      {t("career")}
                    </NavLink>
                  </li>
                  <li className="nav-item">
                    <NavLink to="/contact" className="nav-link">
                      {t("contact")}
                    </NavLink>
                  </li>
                  <li className="nav-item">
                    <button onClick={toggleLanguage} className="language-toggle">
                      {i18n.language === 'en' ? 'FR' : 'EN'}
                    </button>
                  </li>
                </ul>
              </div>

            </div>
          </nav>
        </div>
      </div>
    </div>
  );
};

export default Navbar;